import React from 'react'
import { action } from '@storybook/addon-actions'
import { storiesOf } from '@storybook/react'

import { Money } from 'protos'

import Divider from '@material-ui/core/Divider'

import StoreDailyBonusBar from 'components/StoreDailyBonusBar'

const value = Money.create({ value: 100, currency: 1 })
const remainingSec = 24 * 60 * 60 // 1 day

interface PropsAndState {
  remainingSec: number
}

class StoreDailyBonusBarContainer extends React.Component<PropsAndState, PropsAndState> {
  constructor(props: PropsAndState) {
    super(props)
    this.state = { remainingSec: this.props.remainingSec }
  }

  onCountdownFinished = () => {
    this.setState({ remainingSec: 0 })
  }

  render() {
    return (
      <StoreDailyBonusBar
        value={value}
        remainingSec={this.state.remainingSec}
        onButtonClick={action('onButtonClick')}
        onCountdownFinished={this.onCountdownFinished}
      />
    )
  }
}

storiesOf('StoreDailyBonusBar', module)
  .add('default', () => (
    <>
      <StoreDailyBonusBar onButtonClick={action('onButtonClick')} />
      <Divider />
      <StoreDailyBonusBar value={value} onButtonClick={action('onButtonClick')} />
      <Divider />
      <StoreDailyBonusBar value={value} onButtonClick={action('onButtonClick')} isLoading />
      <Divider />
      <StoreDailyBonusBar value={value} remainingSec={remainingSec} onButtonClick={action('onButtonClick')} />
      <Divider />
      <StoreDailyBonusBarContainer remainingSec={5} />
      <Divider />
    </>
  ))
